import React from "react"

function getOptionsForLanguageEntryDropdown(opts){
  console.log('are we getting opts?', opts)
  return  [
    <option key="default" value={undefined}>{'Select a tag for the Language Entry'}</option>,
    ...opts.map(opt=><option key={opt} value={opt}>{opt}</option>)
  ]
}

export {getOptionsForLanguageEntryDropdown}